import React from 'react';
import { Link } from 'react-router-dom';

const BDBreadcrumb = ({bookingDetails}) => {
  return (
    <div className="bd-p-breadcrumb mb-4">
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <Link to="/bookings">Bookings</Link>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            {bookingDetails?.product_title}
          </li>
        </ol>
      </nav>
    </div>
  );
};

export default BDBreadcrumb;
